<template>
<v-text-field hide-details=""  :tabindex="tabdeger"  v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket" :name="name"   @blur="test()"  @focus="isInputActive=true" >
</v-text-field>




</template>

<script>
export default {
  name: 'currency-input',
  data () {
    return {
      isInputActive: false
    }
  },
  props: ['value', 'tabindex', 'name', 'id', 'etiket','aktif','tabdeger','isPositive'],
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          return this.value.toString()
        } else {
            var result = this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
            if(this.isPositive){
                var controlMinus = result.search('-');
                  if(controlMinus == 0){
                    this.$emit('input',0);
                    return 0;
                  }
            }
            return result;

        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue)
        if (isNaN(newValue)) {
          newValue = 0
        }
        this.$emit('input', newValue)
      }
    }
  },
  methods:{
    test(){
    this.isInputActive=false
    this.$emit('odakkaybi', this.value)
    }
  }
}
</script>

<style scoped>
</style>
